<template>
    <!-- Main area -->
    <div class="mt-4 md:mt-6 mb-4 lg:mb-8">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'SystemContainer',
}
</script>
